import { useState } from 'react'
import { Button, Select } from '@pcln/horizon'
import useBootstrapData from '@/hooks/useBootstrapData'
import { createDateOptions, currentMonth } from '../SearchForm/utils'
import {
  locationOptions,
  cruiseLineOptions,
  durationOptions
} from '../constants'
import { useCruiseFormSubmit } from './useCruiseFormSubmit'
import {
  getGridContainerClass,
  getSubmitButtonClass,
  getInputClass
} from './HorizonCruiseForm.variants'

const createOption = (option: {
  label: string
  value: string
  disabled?: boolean
  selected?: boolean
}) => ({
  label: option.label,
  value: option.value,
  disabled: option.disabled || false
})

const locations = locationOptions.map(createOption)
const cruiseLines = cruiseLineOptions.map(createOption)
const dateOptions = createDateOptions(new Date()).map(createOption)
const durations = durationOptions.map(createOption)

function HorizonCruiseForm({
  useCompactLayout = false
}: {
  useCompactLayout?: boolean
}) {
  const [location, setLocation] = useState('')
  const [cruiseLine, setCruiseLine] = useState('')
  const [startDate, setStartDate] = useState(currentMonth)
  const [duration, setDuration] = useState('')

  const {
    isMobile,
    referral,
    webstats: { clientGUID: cguid }
  } = useBootstrapData()

  const formData = {
    location,
    cruiseLine,
    startDate,
    duration
  }

  const { onSubmit } = useCruiseFormSubmit({
    formData,
    referral,
    cguid,
    isMobile
  })

  return (
    <div className="w-full">
      <form onSubmit={onSubmit} aria-label="cruise search">
        <div className={getGridContainerClass(useCompactLayout)}>
          <Select
            label="Destination"
            isInset
            iconLeft="search"
            menuItems={locations}
            value={location}
            onChange={setLocation}
            placeholder="Destination"
            initialValue="Destination"
            className={getInputClass('destination', useCompactLayout)}
          />

          <Select
            label="Departing"
            iconLeft="calendar_month"
            isInset
            menuItems={dateOptions}
            value={startDate}
            onChange={setStartDate}
            placeholder="Select date"
            className={getInputClass('departure', useCompactLayout)}
          />

          <Select
            iconLeft="calendar_clock"
            label="Cruise Length"
            isInset
            menuItems={durations}
            value={duration}
            onChange={setDuration}
            placeholder="Any length"
            className={getInputClass('length', useCompactLayout)}
          />

          <Select
            iconLeft="directions_boat"
            label="Cruise Line"
            isInset
            menuItems={cruiseLines}
            value={cruiseLine}
            onChange={setCruiseLine}
            placeholder="All cruise lines"
            className={getInputClass('line', useCompactLayout)}
          />

          <Button
            buttonType="submit"
            type="primary"
            size="lg"
            className={getSubmitButtonClass(isMobile, useCompactLayout)}
          >
            Book Now
          </Button>
        </div>
      </form>
    </div>
  )
}

export default HorizonCruiseForm
